import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import { lmsCourses } from '../../../../../../redux/lms/courses/action';
import { selectLMScoursesQueryItems } from '../../../../../../redux/lms/courses/selector';
import LMSCourseComponent from '../components/course.component';
import { lmsTopics } from '../../../../../../redux/lms/topics/action';
import { selectLMSTopicsListItems } from '../../../../../../redux/lms/topics/selector';
import { selectListItems } from '../../../../../../redux/library/selector';

const ManagementLMSCourse = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const parmas: any = useParams();
  const lmsCoursesQuery = useSelector(selectLMScoursesQueryItems);
  const [isQuery, setIsQuery] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [selectLMSCourses, setSelectLMSCourses] = useState<any>({});
  const topicsListItems = useSelector(selectLMSTopicsListItems)
  const libraryData = useSelector(selectListItems)
  const [
    mediaFiles,
    setMediaFiles
  ] = useState<any>([])


  const fetchLMSCoursesQueryById = () => {
    dispatch(lmsCourses.query({
      url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/lms/courses/fetch-detail`,
      entity: 'lmsCourses',
      jsonData: {
        Context: {},
        Records: [
          {
            Id: parmas.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true);
    });
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectLMSCourses({ ...selectLMSCourses, [field]: event });
  }

  // media handle form change
  const handleFormMediaItemChange: any = ({ value }: any) => {
    setMediaFiles(value);
  }

  useEffect(
    () => {
      dispatch(lmsTopics.list({
        url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/lms/topics/list`,
        entity: 'lmsTopics', jsonData: {
        }
      }))

        .then(() => {
          if (parmas?.id > 0) {
            fetchLMSCoursesQueryById()

          } else {
            setIsLoading(false)
          }
        })
    },
    []
  )

  useEffect(() => {
    if (isQuery) {
      setSelectLMSCourses(lmsCoursesQuery?.result?.items);
    }
  }, [isQuery]);

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    mediaFiles.splice(
      mediaFiles.length - 1,
      1
    )
    const eventData = {
      "Id": parmas.id || 0,
      "Title": selectLMSCourses?.Title || '',
      "ShortDescription": selectLMSCourses?.ShortDescription || '',
      "Description": selectLMSCourses?.Description || '',
      "Duration": selectLMSCourses?.Duration || '',
      "DifficultyLevel": selectLMSCourses?.DifficultyLevel || '',
      "LearningOutcomes": selectLMSCourses?.LearningOutcomes || '',
      "CourseFeatures": selectLMSCourses?.CourseFeatures || '',
      "Requirements": selectLMSCourses?.Requirements || '',
      "CourseIncludes": selectLMSCourses?.CourseIncludes || '',
      "IsPublished": selectLMSCourses?.IsPublished || '',
      "DisplayOrder": Number(selectLMSCourses?.DisplayOrder) || '',
      "AuthorId": selectLMSCourses?.AuthorId || '',
      "PublishedDate": selectLMSCourses?.PublishedDate,
      "IsFreeOfCost": selectLMSCourses?.IsFreeOfCost,
      "Price": selectLMSCourses?.Price,
      "Category": selectLMSCourses?.Category,
      "MediaMappings": {
        "MediaFiles": mediaFiles,
        "Templates": []
      }
    };
    if (parmas?.id > 0) {
      await dispatch(lmsCourses.resetAction({ actionType: 'update' }))
      await dispatch(lmsCourses.update({
        url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/lms/courses`,
        entity: 'lmsCourses',
        jsonData: {
          Context: {},
          Records: [eventData],
        }
      })).then(() => {
        back();
      });
    } else {
      await dispatch(lmsCourses.resetAction({ actionType: 'create' }))
      await dispatch(lmsCourses.create({
        url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/lms/courses`,
        entity: 'lmsCourses',
        jsonData: {
          Context: {},
          Records: [eventData],
        }
      })).then(() => {
        back();
      });
    }
  }

  const back = () => {
    navigate('/management/e-applications/lms/courses');
  }

  return (
    <>
      {lmsCoursesQuery?.isLoading ? <PageLoader /> :
        <LMSCourseComponent
          handleInnerFormChange={handleInnerFormChange}
          selectLMSCourses={selectLMSCourses}
          back={back}
          handleFormSubmit={handleFormSubmit}
          onFormItemChange={handleFormMediaItemChange}
          id={parmas?.id}
          TopicsList={topicsListItems?.result?.items}
          libraryData={libraryData?.result?.DifficultyLevel}
          learningPathCategory={libraryData?.result?.LearningPathCategory}
        />
      }
    </>
  );
}

export default ManagementLMSCourse;
